module.exports = "/build/web/svg/event/logo-default-competitie.c459296cdf6f33604b6ab4ca54861e0a.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/event/logo-default-competitie.svg
// module id = 158
// module chunks = 24